import React from 'react';
import { NavLink } from '../NavLink';
import { ProceedButton } from 'components/form-elements/buttons/ProceedButton';

export const Navigator = ({ to, dark, onClick = () => {} }) => (
  <NavLink to={to}>
    <ProceedButton onClick={onClick}>
      <ProceedButton.Button intl="moveOn" />
      <ProceedButton.CircledArrow dark={dark} />
    </ProceedButton>
  </NavLink>
);
